module.exports = __webpack_public_path__ + "img/01_1986_iPad_L.7cfb7f00.jpg";